export enum CAPABILITY {
  CREATE_PROJECT = 1,
  DELETE_ANY_COMMENT = 2, // handled on server side
  ADMINISTRATION = 3,
  CREATE_AUDIT_REPORT = 4,
  DOWNLOAD_SYSTEM_LOGS = 17,
  USE_PRIVATE_WORKSPACE = 18, // handled on server side
  PRIVATE_SAVING = 19,
  PROJECT_COMMENTS = 20,
  DELETE_SAMPLES = 22,
  LAUNCH_ANALYST = 32,
  LAUNCH_PROCESSOR = 35,
  LAUNCH_ARRAY = 37,
  BLAST = 39,
  PHENOTYPE_EDITING = 40,
  SEQUENCE_UPLOAD = 42,
  SEQUENCE_DELETION = 43,
  PUBLISH_WORKFLOWS = 82,
  CREATE_VIRTUAL_GENOME = 83,
  LAUNCH_CLASSIC_PROCESSOR = 84,
  SAMPLE_LOCKING = 85,
  SAMPLE_UNLOCKING = 86,
  VIEW_PLAYBOOK_EXECUTION_LOGS = 87,
  REST_API_ACCESS = 100,
}
